import React, { useState } from 'react';
import { Link } from 'gatsby';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
const AudienceNavigation = ({
  heading,
  body,
  image,
  path,
  index,
  installState,
  setInstallState,
  isInstallationPage,
}) => {
  return (
    <>
      {image && (
        <div className="link-container" key={index}>
          <div className="navigation-icon">
            <LitImage image={image} alt="blue icon" />
          </div>
          <div className="navigation-header">
            {heading.value !== null ? (
              <LitStructuredText data={heading} basic />
            ) : (
              heading
            )}
          </div>
          {body && (
            <p className="navigation-content">
              {body.value !== null ? (
                <LitStructuredText data={body} basic />
              ) : (
                body
              )}
            </p>
          )}
          <div className="navigation-go-section">
            <Link
              to={`#${path}`}
              className="navigation-link"
              onClick={() => {
                {
                  isInstallationPage &&
                    (path === 'undergroundInstalls'
                      ? setInstallState(true)
                      : path === 'overheadInstalls'
                        ? setInstallState(false)
                        : setInstallState(!installState));
                }
              }}
            >
              Find out more
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default AudienceNavigation;
